import React from "react"
import { Modal, Box, Button, makeStyles, Theme } from "@material-ui/core"
import { useTranslation } from "react-i18next"

export const OnboardingGuideModal = ({
  gridId,
  message,
  onComplete,
  allowMask = false,
}: {
  gridId: string
  message: string[]
  onComplete: () => void
  allowMask?: boolean
}) => {
  const classes = useStyles()
  const { t: translations } = useTranslation("treegrid")
  const [rect, setRect] = React.useState<DOMRect | null>(null)

  React.useEffect(() => {
    let attempts = 0
    const findAddButton = () => {
      const gridElement = document.getElementById(gridId)
      const addButton = gridElement?.querySelector<HTMLElement>("#addTaskButtonClickArea, .TWAddButton")

      if (addButton) {
        setRect(addButton.getBoundingClientRect())
      } else if (attempts < 15) {
        attempts++
        setTimeout(findAddButton, 300)
      }
    }

    findAddButton()
  }, [gridId])

  if (!rect) return null

  return (
    <Modal open onClose={onComplete}>
      <div className={classes.modalRoot}>
        {/* Tooltip */}
        <Box
          className={classes.tooltip}
          style={{
            top: rect.bottom + 8,
            left: rect.left,
          }}
        >
          <h4 className={classes.title}>{translations("firstTaskAdded")}</h4>
          {message.map((paragraph, i) => (
            <p key={i} className={classes.description}>
              {paragraph}
            </p>
          ))}
          <Button variant="contained" color="primary" onClick={onComplete}>
            {translations("gotIt")}
          </Button>
        </Box>

        {/* Dark overlay with hole */}
        <svg className={classes.svgOverlay}>
          <defs>
            {allowMask && (
              <mask id="hole">
                <rect width="100%" height="100%" fill="white" />
                <rect
                  x={rect.left - 5}
                  y={rect.top - 5}
                  width={rect.width + 10}
                  height={rect.height + 10}
                  rx={4}
                  fill="black"
                />
              </mask>
            )}
          </defs>
          <rect width="100%" height="100%" fill="rgba(0,0,0,0.7)" mask="url(#hole)" />
        </svg>
      </div>
    </Modal>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  modalRoot: {
    position: "fixed",
    inset: 0,
  },
  tooltip: {
    position: "absolute",
    background: theme.palette.background.paper,
    paddingTop: theme.spacing(0),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    borderRadius: theme.shape.borderRadius * 2,
    width: 350,
    boxShadow: theme.shadows[6],
    zIndex: 1400,
  },
  title: {
    marginBottom: theme.spacing(1),
    color: theme.palette.primary.main,
  },
  description: {
    fontSize: 14,
    lineHeight: 1.5,
    color: theme.palette.text.secondary,
  },
  svgOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 1399,
    pointerEvents: "none",
  },
}))
